import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_GPT_RECOMMENDATION_LOG_PENDING,
  GET_GPT_RECOMMENDATION_LOG,
  SG_GET_GPT_RECOMMENDATION_LOG,
  DELETE_GPT_RECOMMENDATION_LOG,
  SG_DELETE_GPT_RECOMMENDATION_LOG,
  FETCH_GPT_RECOMMENDATION_LOG,
  SG_FETCH_GPT_RECOMMENDATION_LOG,
  EDIT_GPT_RECOMMENDATION_LOG,
  SG_EDIT_GPT_RECOMMENDATION_LOG,
  ADD_GPT_RECOMMENDATION_LOG,
  SG_ADD_GPT_RECOMMENDATION_LOG,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";


function* loadmethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_LOG_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_GPT_RECOMMENDATION_LOG, action.payload);
    // console.log(json.data)
    yield put({ type: GET_GPT_RECOMMENDATION_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_GPT_RECOMMENDATION_LOG, loadmethods);
}


function* fetchmethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_LOG_PENDING });
  try {
    const json = yield call(api.FETCH_GPT_RECOMMENDATION_LOG, action.payload);
    yield put({ type: FETCH_GPT_RECOMMENDATION_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_GPT_RECOMMENDATION_LOG, fetchmethods);
}



function* updatemethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_LOG_PENDING });
  try {
    const json = yield call(api.EDIT_GPT_RECOMMENDATION_LOG, action.payload);
    yield put({ type: EDIT_GPT_RECOMMENDATION_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeEvery(SG_EDIT_GPT_RECOMMENDATION_LOG, updatemethods);
}

function* addmethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_LOG_PENDING });
  try {
    const json = yield call(api.ADD_GPT_RECOMMENDATION_LOG, action.payload);
    yield put({ type: ADD_GPT_RECOMMENDATION_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_GPT_RECOMMENDATION_LOG, addmethods);
}

function* deletemethods(action) {
    yield put({ type: GET_GPT_RECOMMENDATION_LOG_PENDING });
  try {
    yield call(api.DELETE_GPT_RECOMMENDATION_LOG, action.payload);
    yield put({ type: DELETE_GPT_RECOMMENDATION_LOG, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_GPT_RECOMMENDATION_LOG, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
